import { useStaticQuery, graphql } from 'gatsby';

const useSiteMetadata = () => {
  const { site } = useStaticQuery(
    graphql`
      query SiteMetaData {
        site {
          siteMetadata {
            title
            siteUrl
            image
            sanityProjectId
            sanityDataset
            navItems {
              name,
              path,
              heroImageSanityName
            }
          }
        }
      }
    `,
  );
  return site.siteMetadata;
};

export default useSiteMetadata;
